export default __webpack_public_path__ + "static/media/curve.e1ccef2b.png";